import React,{useState} from "react";
import HeaderComp from "../HeaderComponent/HeaderComp";
import "../../Styles/loginPage.scss";
import { useLoginForm } from "../../hooks/useLoginForm";
import { useNavigate } from "react-router-dom";
import { validationMessage } from "../../constants/textConstants";
import { rules } from "../../utils/rules";
import { Visibility, VisibilityOff } from '@mui/icons-material';
export default function Login() {
  const navigate = useNavigate();
  const { register, handleSubmit, onSubmit, errors,isValid } = useLoginForm();

  const forgotPasswordHandle = () => {
    navigate("/forgot-password")
  };

  const onSubmitHandler = (data) => {
    onSubmit(data);  
  };
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <HeaderComp />
      <div className="loginDiv">
        <div className="formDiv">
          <div className="loginDesc">
            <div className="loginHead">Tentkotta’s distributor portal login</div>
            <div className="loginSubDiv">Access your movies and content management tools.</div>
          </div>

          <form className="auth_container" onSubmit={handleSubmit(onSubmitHandler)}>
            <div className="form-group">
              <input
                id="Email"
                placeholder="Email"
                type="email"
                name="email"
                className={`tkTextField`}
                {...register("email", { 
                  required: validationMessage.email_req,
                  pattern: {
                    value: rules.validation.email,
                    message: validationMessage.email_invalid,
                  },
                })} 
              />
              <label htmlFor="Email">Email</label>
              {errors.email && <span  className="error-message">{errors.email.message}</span>} 
            </div>

            <div className="form-group position-relative">
            <input
              id="Password"
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              name="password"
              autoComplete="password"
              {...register("password", { required: validationMessage.password_req })}
            />
            <label htmlFor="Password">Password</label>
            <button
              type="button"
              className="password-toggle-btn"
              onClick={togglePasswordVisibility}
              aria-label={showPassword ? "Hide password" : "Show password"}
              >
              {showPassword ? <Visibility /> : <VisibilityOff />}
              </button>
              {errors.password && (
                <span className="error-message">{errors.password.message}</span>
              )}
            </div>

            <div className="forgotPwdDiv">
              <div onClick={forgotPasswordHandle} className="forgetpwdLink">
                Forgot password?
              </div>
            </div>

            <button
              type="submit"
              autoComplete="off"
              className="login_button hover-btn-animation"
              disabled={!isValid}
            >
            LOGIN
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
